import React from 'react';

import { useSelector } from 'react-redux';

import { SupportedLang } from '../../../../../../types/common';
import { SvgImage } from '../../../../shared/components';
import CalendarIcon from '../../../../shared/components/calendar-icon';
import Spin from '../../../../shared/components/spin';
import { ImageName } from '../../../../shared/components/svg-image/images';
import style from './index.css';

const langIconMap: Record<SupportedLang, ImageName> = {
    ru: 'calendarTextRU',
    en: 'calendarTextEN',
    uk: 'calendarTextUK',
    tr: 'calendarTextTR',
};

const Loader: React.FC = () => {
    const appLang = useSelector((state) => state.config.appLang);

    return (
        <div className={style.container}>
            <CalendarIcon />
            <SvgImage className={style.text} imageName={langIconMap[appLang]} />
            <Spin className={style.loader} size="lg" progress />
        </div>
    );
};

export default Loader;
